import { Component, OnInit } from '@angular/core';
import { FrattaleService } from 'src/app/services/frattale.service';
import { Hilo} from 'src/app/models/hilo'
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-dailyhilo-backtest',
  standalone: true,
  templateUrl: './dailyhilo-backtest.component.html',
  styleUrls: ['./dailyhilo-backtest.component.scss'],
  imports: [CommonModule]
})
export class DailyhiloBacktestComponent implements OnInit {
  markets: [] = [];
  dati: Array<Hilo> = [];
  trades = Array<Object>();

  constructor(private service: FrattaleService) { }

  ngOnInit(): void {
    this.service.getMarketsSymbols().subscribe((data: any) => {
      this.markets = data['data'];
    })
    this.service.getDailyBang().subscribe((data: any) => {
      let dd = data['data']
      dd.map((item: any) => {
        item.rawal = (item.sumpos/item.numpos)/((item.sumpos-item.profit)/(item.num-item.numpos))
        item.percpos = item.numpos/item.num*100
        item.profitpip = item.profit/item.num/item.pip
      })
      this.dati = data['data']
      //this.dati = this.dati.filter((item: any)=> item.profit>0)
      console.log(this.dati)
    })
  }

  calcolaBT(){ 
    this.dati.map((item: any)=>{
        console.log(item)
        this.service.btDaily(item.market, item.dayweek, item.swing, item.verso).subscribe((data: any)=>{
          
          let d = data['dato']
          let profit = d.map((item: any)=> item.profit).reduce((prev: number, curr: number) => curr ? prev+curr : prev, 0)
          item.profit2 = profit
          let p3 = d[d.length-1].profit
          item.profit3 = p3
          this.trades.push({system: item, result: d})
          console.log(this.trades);
        })
      })
  }

}
